<template>
  <section class="relative z-10 mt-36 sm:mt-20 lg:-mt-28">
    <div class="lg:container container-fluid">
      <div class="relative shrink-0">
        <img
          v-if="bannerUrl"
          :src="bannerUrl"
          class="w-full h-64 object-cover lg:rounded-xl shadow dark:shadow-gray-700"
          alt=""
        >
        <div v-else class="w-full h-64 bg-gradient lg:rounded-xl shadow dark:shadow-gray-700"></div>
      </div>

      <div class="px-8 lg:px-10 -mt-[72px]">
        <div class="relative flex items-end justify-between">
          <img
            :src="logoUrl || placeholderLogo"
            class="size-28 rounded-full shadow dark:shadow-gray-800 ring-4 ring-slate-50 dark:ring-slate-800"
            alt="Avatar"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import placeholderAvatar from '@/assets/images/job/placeholder/job8.png';
import placeholderAvatarBanner from '@/assets/images/placeholder/avatar-banner.svg';

export default {
  props: {
    logoUrl: {
      type: String,
      required: false,
    },
    bannerUrl: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      placeholderLogo: placeholderAvatar,
      placeholderBanner: placeholderAvatarBanner,
    }
  },
}
</script>
